export default __webpack_public_path__ + "static/media/avatar_admin.998fe9b2.svg";